import React, { useState, useEffect } from 'react'
import PedidoPos from './posBody/PedidoPos'
import Subtotales from './posBody/Subtotales'
import CategoriasPos from './posBody/CategoriasPos'
import ProductosPos from './posBody/ProductosPos'
import ModalAtributos from './posBody/ModalAtributos'
import ModalProductos from './posBody/ModalProductos'
import PasarelaPago from './posBody/PasarelaPago'
import axios from 'axios'
import PeticionTraeDatos from '../../componentesAdmin/hooks/useTraeDatos'
import { MDBBtn, MDBModal, MDBModalBody, MDBModalFooter, MDBModalHeader } from 'mdbreact'
import { ReactComponent as CodigoQRLogo } from '../../paginas/icons/codeqr.svg';
import { NumericFormat } from 'react-number-format'

function eliminarDiacriticos(texto) {
    texto = texto.toLowerCase();
    return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}


const PosBody = ({ baseUrl, listaAtributos, mediosDePago, cierre, UrlUbicaciones, UrlDomiciliarios, urlConfiguraciones, rutaCargas, rutaReglasEnvio, rutaCupones, buscador, codigoBarras, cambiarCodigoBarras, productos, vistaMovil, setVistaMovil }) => {

    const [clienteRegis, setClienteRegis] = useState()
    const [pedido, setPedido] = useState([])
    const [subTotal, setSubTotal] = useState({ total: 0, subtotal: 0, descuento: 0, impuesto_nombre: '', valor_impuesto: 0, })
    const [categoriasFull, setCategoriasFull] = useState([])
    const [configuraciones] = PeticionTraeDatos(urlConfiguraciones)

    const [precioCargas] = PeticionTraeDatos(rutaCargas)
    const [reglasCargas] = PeticionTraeDatos(rutaReglasEnvio)
    const [cuponPrecio, setCuponPrecio] = useState(0)

    const [checkDomi, setCheckDomi] = useState(false)

    //producto seleccionado
    const [productoSelect, setProductoSelect] = useState({ atributos: [{ opciones: [], }] })


    const baseUrlCat = baseUrl + 'categorias/'

    //estados: ---------------------------------------

    const [funcion, setFuncion] = useState('ver')
    const [funcionPro, setFuncionPro] = useState('ver')
    //Atributos terminados y concatenados listos para subir al pedido
    const [atributosTerminados, setAtributosTerminados] = useState([])


    const [categorias, setCategorias] = useState([])
    const [filtroCambio, setFiltroCambio] = useState('2')

    //estados de modal:
    const [modalAtri, setModalAtri] = useState(false)
    //estado para sacar nombre de atributo de productos
    const [atribuCatModal, setAtribuCatModal] = useState([])


    //estados modal ver pedidos:
    const [modalProd, setModalProd] = useState(false)

    //estados modal ver pedidos:
    const [estadoPasarela, setEstadoPasarela] = useState(false)

    const [textoBuscador, setTextoBuscador] = useState('')
    const [textoCodigoBarras, setTextoCodigoBarras] = useState('')
    const [productosQr, setProductosQr] = useState([])
    const [productoSeleccionadoQr, setProductoSeleccionadoQr] = useState()

    const [clienteTemporalSeleccionado, setClienteTemporalSeleccionado] = useState()

    const [Obsequio, setObsequio] = useState(false)
    const [totalaPagar, setTotalaPagar] = useState(0)

    const onClickObsequio = () => setObsequio(!Obsequio)


    const cambiarTextoBuscador = (e) => {
        const texto = e.target.value
        setTextoBuscador(eliminarDiacriticos(texto))
    }

    const cambiarTextoCodigoBarras = (e) => {
        const texto = e.target.value
        const productosQr = productos.filter(pro => pro.id == texto)
        setProductosQr(productosQr)
        setTextoCodigoBarras(texto)
    }


    //funciones: ----------------------
    const ReiniciaSis = () => {
        setPedido([])
        setAtribuCatModal([])
        setProductoSelect({ atributos: [{ opciones: [], }] })
        setAtributosTerminados([])
        setClienteRegis()
        setSubTotal({ total: 0, subtotal: 0, descuento: 0, impuesto_nombre: '', valor_impuesto: 0, })
        setObsequio(false)
    }

    const verProducto = producto => e => {
        setProductoSelect(producto)
        setModalProd(!modalProd)
    }

    const RebajaoNo = producto => {
        let RebajaoNo = 0
        parseFloat(producto.precio_rebajado) > 0 ?
            RebajaoNo = parseFloat(producto.precio_rebajado)
            : RebajaoNo = parseFloat(producto.precio_producto)
        return RebajaoNo
    }
    const handleClickSelectProducto = async (producto) => {
        try {
            if (producto.inventario === "true") {
                const { data: obtenerAtributos } = await axios(baseUrl + 'inventarios/', {
                    params: {
                        idProducto: producto.id
                    }
                })

                if (producto.combo == "true") {
                    setProductoSelect(producto)
                } else {
                    const atributos = []
                    producto.atributos.map(atri => {
                        const opciones = []
                        const verificarAtributos = obtenerAtributos.find(a => a.padre == atri.nombre)

                        atri.opciones.map(op => {
                            const cantidad = obtenerAtributos.find(a => a.nombre == op.opcion)

                            if (cantidad) {
                                opciones.push({
                                    ...op,
                                    idAtributo: cantidad.idAtributo,
                                    cantidad: parseInt(cantidad.cantidad),
                                    precio: op.precio ? parseFloat(op.precio) : RebajaoNo(producto)
                                })
                            }

                        })
                        if (verificarAtributos && parseInt(verificarAtributos.cantidad) > 0) {
                            atributos.push({
                                nombre: atri.nombre,
                                opciones
                            })
                        }
                    })

                    setProductoSelect({ ...producto, atributos })
                }


            } else {
                if (producto.combo == "true") {
                    setProductoSelect(producto)
                } else {

                    const atributos = []
                    producto.atributos.map(atri => {
                        const opciones = []
                        atri.opciones.map(op => {
                            if (op !== "") {
                                opciones.push({
                                    ...op,
                                    precio: RebajaoNo(producto)
                                })
                            }

                        })
                        atributos.push({
                            nombre: atri.nombre,
                            opciones
                        })

                    })
                    setProductoSelect({ ...producto, atributos })

                }

            }

            if (productoSeleccionadoQr && productoSeleccionadoQr?.atributos && productoSeleccionadoQr?.atributos.length > 0) {
                return setModalAtri(true);
            }

            if (productoSeleccionadoQr) {
                return ManejaClickSubeProducto(productoSeleccionadoQr, [])
            }
            setModalAtri(true)
            //document.body.classList.add('modal-open');
        } catch (error) {
            console.log(error)
        }

    }

    const controlModalAtri = e => setModalAtri(!modalAtri)
    const controlModalProd = e => setModalProd(!modalProd)
    const controlPasarela = e => {
        setVistaMovil('caja')
        setCuponPrecio(0)
        setEstadoPasarela(!estadoPasarela)
    }

    const handleClickCategoria = categoria => e => setFiltroCambio(categoria)


    const Descuento = producto => {
        let descuento = 0

        producto.precio_rebajado > 0 ?
            descuento = producto.precio_producto - producto.precio_rebajado
            : descuento = 0

        return descuento
    }

    const CalculaImpuesto = (impuest, valor) => {
        let taxes = (parseFloat(valor) * parseInt(configuraciones ? configuraciones[10].valor : 0) / 100)

        return parseFloat(taxes.toFixed(2))
    }

    const ManejaClickSubeProducto = (producto, atributosTerminados) => {
        if (producto.inventario == "true" && producto.combo === 'false') {

            if (atributosTerminados.length == 0 && producto.atributos.length > 0) return null

            const validarAplicaDescuento = atributosTerminados[0]?.precio === RebajaoNo(producto)

            setPedido([...pedido, {
                id_producto: producto.id,
                nombre_producto: producto.nombre_producto,
                precio_producto: validarAplicaDescuento ? parseFloat(producto.precio_producto) : producto.atributos.length > 0 ? atributosTerminados[0].precio : parseFloat(producto.precio_producto),
                precio_rebajado: validarAplicaDescuento ? parseFloat(producto.precio_rebajado) : 0,
                atributos: atributosTerminados,
                cantidad_producto: 1,
                cantidad: 1,
                impuesto_producto: producto.impuesto_producto,
                url_imagen: producto.url_imagen,
                total_pedido: validarAplicaDescuento ? RebajaoNo(producto) : producto.atributos.length > 0 ? atributosTerminados[0].precio : RebajaoNo(producto),
                descuento: validarAplicaDescuento ? Descuento(producto) : 0,
                inventario: producto.atributos.length > 0 ? atributosTerminados[0]?.inventario : producto.inventarioCantidad ? producto.inventarioCantidad : null,
                valorImpuesto: CalculaImpuesto(producto.impuesto_producto, RebajaoNo(producto)),
                categoria_producto: producto.categoria_producto,
                carga: parseFloat(producto.carga),
                descuentoCupones: producto.descuentoCupones
            }])
            setModalAtri(false)
            setAtributosTerminados([])
        } else {

            if (atributosTerminados.length == 0 && producto.atributos.length > 0 && producto.combo === "false") return null

            setModalAtri(false)
            setPedido([...pedido, {
                ...producto,
                categoria_producto: producto.categoria_producto,
                id_producto: producto.id,
                nombre_producto: producto.nombre_producto,
                precio_producto: parseFloat(producto.precio_producto),
                precio_rebajado: parseFloat(producto.precio_rebajado),
                atributos: producto.combo === "true" ? producto.atributos : atributosTerminados,
                cantidad_producto: 1,
                cantidad: 1,
                impuesto_producto: producto.impuesto_producto,
                url_imagen: producto.url_imagen,
                total_pedido: RebajaoNo(producto),
                descuento: Descuento(producto),
                inventario: producto.combo === "true" ? producto.inventarioCantidad : producto.inventario,
                valorImpuesto: CalculaImpuesto(producto.impuesto_producto, RebajaoNo(producto)),
                carga: parseFloat(producto.carga),
                descuentoCupones: producto.descuentoCupones
            }
            ])
            setAtributosTerminados([])
        }
    }

    //Crea una Array nuevo remplaza los datos y lo setea con datos nuevos
    const ManejaClickSumaPedido = index => e => {
        e.preventDefault()
        let newArr = pedido.map((item, i) => {
            if (index === i) {
                let suma = item.cantidad_producto + 1
                if (item.atributos.length > 0) {
                    item.atributos[0].cantidad = suma
                }

                return {
                    ...item,
                    cantidad_producto: suma,
                    cantidad: suma,
                    total_pedido: RebajaoNo(item) * suma,
                    descuento: Descuento(item) * suma,
                    valorImpuesto: CalculaImpuesto(item.impuesto_producto, RebajaoNo(item)) * suma
                }
            } else { return item; }
        });
        setPedido(newArr);
    }

    const ManejaClickRestaPedido = (index, parametro) => e => {
        e.preventDefault()
        let newArr = pedido.map((item, i) => {
            if (index === i) {
                if (item.cantidad_producto > 1) {
                    let resta = item.cantidad_producto - 1
                    if (item.atributos.length > 0) {
                        item.atributos[0].cantidad = resta
                    }

                    return {
                        ...item,
                        cantidad_producto: item.cantidad_producto - 1,
                        cantidad: item.cantidad_producto - 1,
                        total_pedido: RebajaoNo(item) * resta,
                        descuento: Descuento(item) * resta,
                        valorImpuesto: CalculaImpuesto(item.impuesto_producto, RebajaoNo(item)) * resta
                    }
                } else { return item; }
            } else { return item; }
        });
        setPedido(newArr);

    }

    const ManejaClickEliminaPedido = index => e => {
        e.preventDefault()
        setPedido(pedido => pedido.filter((id_producto, cont) => cont !== index));
    }

    const peticionTraeCategorias = () => {
        axios.get(baseUrlCat)
            .then(response => {
                setCategoriasFull(response.data)
                setFuncion('ver')
            })
    }

    useEffect(() => {
        //  peticionTraeDatos()
        peticionTraeCategorias()


    }, [])

    useEffect(() => {
        //carga categorias -----------------------------------------------------
        let newCat = []
        productos.map((cat, i) => {

            let cate = cat.categoria_producto
            cate.map((item, i) => {
                if (item != 'todo') {
                    newCat.push(item)
                }
            })
        });

        //Limpia categorias duplicadas en array de categorias:
        newCat = Array.from(new Set(newCat));

        setCategorias(newCat)

    }, [productos])


    useEffect(() => {
        //suma totales de los arrays
        const total = pedido.reduce((prev, next) => prev + next.total_pedido, 0);

        const descuento = pedido.reduce((prev, next) => prev + next.descuento, 0);
        let totalCargas = pedido.reduce((prev, next) => prev + next.carga, 0);

        let costoEnvio = 0

        if (reglasCargas && precioCargas && totalCargas && checkDomi) {
            if (parseFloat(total) >= parseFloat(reglasCargas[0].minimo) && parseFloat(total) >= parseFloat(reglasCargas[0].minimo)) {
                costoEnvio = parseFloat(reglasCargas[0].precio)
            } else {
                costoEnvio = precioCargas.find(carga => parseFloat(totalCargas) >= parseFloat(carga.minima) && parseFloat(totalCargas) <= parseFloat(carga.maxima))?.precio || 0
            }
        }

        const totalCupones = pedido.reduce((prev, next) => next.descuentoCupones == "true" ? prev + next.total_pedido : prev + 0, 0);

        let cupones = (parseFloat(totalCupones) * parseFloat(cuponPrecio) / 100)

        let subtotal = (total - cupones)

        let valor_impuesto = (parseFloat(subtotal) * parseFloat(configuraciones ? configuraciones[10]?.valor : 0) / 100).toFixed(2);

        let totalSuma = parseFloat(valor_impuesto) + parseFloat(subtotal) + parseFloat(costoEnvio)

        let totalEfectivo = parseFloat(subtotal) + parseFloat(costoEnvio)
        let descuentoTotal = descuento + cupones
        totalSuma = Obsequio ? 0 : totalSuma.toFixed(2)
        valor_impuesto = Obsequio ? 0 : valor_impuesto
        subtotal = Obsequio ? 0 : subtotal
        totalCargas = Obsequio ? 0 : totalCargas.toFixed(2)
        descuentoTotal = Obsequio ? 0 : descuentoTotal.toFixed(2)
        costoEnvio = Obsequio ? 0 : costoEnvio
        subtotal = (total - cupones).toFixed(2)
        cupones = cupones.toFixed(2)
        totalEfectivo = Obsequio ? 0 : totalEfectivo.toFixed(2)
        cupones = parseFloat(cupones)

        setSubTotal({
            costoEnvio,
            subtotal,
            total: totalSuma,
            valor_impuesto,
            descuento: descuentoTotal,
            totalCargas,
            cuponPrecio,
            cupones,
            totalCupones,
            impuesto_nombre: 'Taxes',
            totalEfectivo,
            totalaPagar
        })
    }, [pedido, checkDomi, cuponPrecio, Obsequio, totalaPagar]) //escuha cambio en el estado de tamaño pedido

    const handleProductoSeleccionadoQr = (pro) => {
        if (pro.id === productoSeleccionadoQr?.id) {
            return setProductoSeleccionadoQr()
        }
        setProductoSeleccionadoQr(pro)
    }

    const handleProductoSeleccionadoQrOk = () => {
        handleClickSelectProducto(productoSeleccionadoQr)
        setProductoSeleccionadoQr()
        setTextoCodigoBarras('')
        cambiarCodigoBarras()
        setProductosQr([])
    }

    return (
        <>

            {/* Escritorio*/}
            <div className='d-none d-sm-none d-md-flex escritorio-pedidos'>
                <div className='col-md-5 p-0 animate__animated animate__fadeInTopLeft '>
                    <div className='pedido-container' >
                        <PedidoPos
                            pedido={pedido}
                            onClickSuma={ManejaClickSumaPedido}
                            onClickResta={ManejaClickRestaPedido}
                            onClickElimina={ManejaClickEliminaPedido}
                            onClickModalProd={verProducto}
                        />
                        <Subtotales
                            cuenta={subTotal}
                            onClick={controlPasarela}
                            estadoPasarela={estadoPasarela}
                            cierre={cierre}
                            checkDomi={checkDomi}
                        />

                    </div>
                </div>


                <div className='col-md-7 p-0 m-0'>
                    <div className='pedido-container' >
                        {estadoPasarela ?
                            <PasarelaPago
                                Obsequio={Obsequio}
                                onClickObsequio={onClickObsequio}
                                setCheckDomi={setCheckDomi}
                                checkDomi={checkDomi}
                                rutaCupones={rutaCupones}
                                baseUrl={baseUrl}
                                totalPedido={subTotal}
                                mediosDePago={mediosDePago}
                                ReiniciaSis={ReiniciaSis}
                                pedido={pedido}
                                subTotal={subTotal}
                                clienteRegis={clienteRegis}
                                setClienteRegis={setClienteRegis}
                                UrlDomiciliarios={UrlDomiciliarios}
                                UrlUbicaciones={UrlUbicaciones}
                                setCuponPrecio={setCuponPrecio}
                                Impuesto={configuraciones[10].valor}
                                setTotalaPagar={setTotalaPagar}
                                totalaPagar={totalaPagar}
                                clienteTemporalSeleccionado={clienteTemporalSeleccionado}
                                setClienteTemporalSeleccionado={setClienteTemporalSeleccionado}
                            />

                            :
                            <>
                                {buscador ?
                                    <div className='pos-buscador'>
                                        <div className='col-12'>
                                            <input
                                                placeholder='Buscar...'
                                                type="text"
                                                className="form-control rounded-pill buscador"
                                                id="formGroupExampleInput"
                                                onChange={cambiarTextoBuscador}
                                                value={textoBuscador}
                                            />
                                        </div>
                                    </div>
                                    : null}
                                <CategoriasPos
                                    funcion={funcion}
                                    categorias={categorias}
                                    onClick={handleClickCategoria}
                                    categoriasFull={categoriasFull}
                                />
                                <ProductosPos
                                    funcion={funcionPro}
                                    textoBuscador={textoBuscador}
                                    baseUrl={baseUrl}
                                    filtro={filtroCambio}
                                    productos={productos}
                                    onClick={handleClickSelectProducto}
                                />
                            </>

                        }
                    </div>
                </div>
            </div>

            {/*Movil*/}

            <div className='d-flex d-sm-flex d-md-none'>
                {
                    {
                        'ver': <div className='pedido-container' >
                            {buscador ?
                                <div className='row pos-buscador'>
                                    <div className='col-12'>
                                        <input
                                            placeholder='Buscar...'
                                            type="text"
                                            className="form-control rounded-pill buscador"
                                            id="formGroupExampleInput"
                                            onChange={cambiarTextoBuscador}
                                            value={textoBuscador}
                                        />
                                    </div>
                                </div>
                                : null}
                            <CategoriasPos
                                funcion={funcion}
                                categorias={categorias}
                                onClick={handleClickCategoria}
                                categoriasFull={categoriasFull}
                            />
                            <ProductosPos
                                funcion={funcionPro}
                                textoBuscador={textoBuscador}
                                baseUrl={baseUrl}
                                filtro={filtroCambio}
                                productos={productos}
                                onClick={handleClickSelectProducto}
                            />
                            <div className="boton-ver-pedido-vista-movil">
                                <button
                                    onClick={() => { setVistaMovil('pedido') }}
                                    className="btn boton_estandar-subtotal">
                                    Ver Pedido
                                </button>
                            </div>

                        </div>,
                        'pedido':
                            <div className='pedido-container' >
                                <div className='text-center my-2'><h5>Pedido:</h5></div>
                                <PedidoPos
                                    pedido={pedido}
                                    onClickSuma={ManejaClickSumaPedido}
                                    onClickResta={ManejaClickRestaPedido}
                                    onClickElimina={ManejaClickEliminaPedido}
                                    onClickModalProd={verProducto}
                                />
                                <Subtotales
                                    cuenta={subTotal}
                                    onClick={controlPasarela}
                                    estadoPasarela={estadoPasarela}
                                    cierre={cierre}
                                    checkDomi={checkDomi}
                                />

                            </div>,
                        'caja':
                            <div className='d-flex flex-wrap pasarela-movil-container'>
                                <PasarelaPago
                                    Obsequio={Obsequio}
                                    onClickObsequio={onClickObsequio}
                                    setCheckDomi={setCheckDomi}
                                    checkDomi={checkDomi}
                                    rutaCupones={rutaCupones}
                                    baseUrl={baseUrl}
                                    totalPedido={subTotal}
                                    mediosDePago={mediosDePago}
                                    ReiniciaSis={ReiniciaSis}
                                    pedido={pedido}
                                    subTotal={subTotal}
                                    clienteRegis={clienteRegis}
                                    setClienteRegis={setClienteRegis}
                                    UrlDomiciliarios={UrlDomiciliarios}
                                    UrlUbicaciones={UrlUbicaciones}
                                    setCuponPrecio={setCuponPrecio}
                                    setVistaMovil={setVistaMovil}
                                />
                            </div>
                    }[vistaMovil]
                }

            </div>
            {modalAtri ?
                <ModalAtributos
                    producto={productoSelect}
                    estadoModal={modalAtri}
                    controlModalAtri={controlModalAtri}
                    nombreAtributos={atribuCatModal}
                    listaAtributos={listaAtributos}
                    ManejaClickSubeProducto={ManejaClickSubeProducto}
                    atributosTerminados={atributosTerminados}
                    setAtributosTerminados={setAtributosTerminados}
                    baseUrl={baseUrl}
                />
                : null}
            {
                modalProd ?
                    <ModalProductos
                        baseUrl={baseUrl}
                        estadoModal={modalProd}
                        controlModalProd={controlModalProd}
                        pedido={productoSelect}
                    />
                    : null
            }
            <MDBModal isOpen={codigoBarras} toggle={cambiarCodigoBarras} size='sm'>
                <MDBModalHeader>
                    <CodigoQRLogo className='codigoQrLogo' width={30} height={30} />
                    Busca por Código
                </MDBModalHeader>
                <MDBModalBody className='p-0'>
                    <div className='px-3'>
                        <input
                            placeholder='Buscar...'
                            type="text"
                            className="form-control rounded-pill buscador z-depth-1"
                            id="formGroupExampleInput"
                            onChange={cambiarTextoCodigoBarras}
                            value={textoCodigoBarras}
                        />
                    </div>

                    <div className='z-depth-1 mt-3 container-productosQr'>
                        {productosQr && productosQr.map(pro => (
                            <div className={`py-3 producto-qr-container ${pro.id == productoSeleccionadoQr?.id ? 'active' : ''}`} key={pro.id} onClick={() => handleProductoSeleccionadoQr(pro)}>
                                <div className='col-6 pr-0'>
                                    <img src={baseUrl + 'productos/' + pro.imagePrev}
                                        className="img-responsive imageProducto" />
                                </div>
                                <div className='col-6'>
                                    <p>{pro.nombre_producto}</p>
                                    <NumericFormat value={pro.precio_producto} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalSeparator={'.'} />
                                </div>
                            </div>
                        ))
                        }
                    </div>

                </MDBModalBody>
                <MDBModalFooter className='border-0'>
                    {productoSeleccionadoQr &&
                        <button className="btn boton_estandar-subtotal" onClick={handleProductoSeleccionadoQrOk}>¡OK!</button>
                    }
                </MDBModalFooter >

            </MDBModal>
        </>
    )
}


export default PosBody